export default function normalizeString(str) {
    return str
      .normalize('NFD')                   // separa letras y acentos
      .replace(/[\u0300-\u036f]/g, '')    // elimina los acentos
      .replace(/\s+/g, '-')               // reemplaza espacios por guiones
      .toLowerCase();                     // convierte a minúsculas
}